<template>
  <NotionWiki :homeId="homeId" :rootId="rootId" :name="name" />
</template>

<script>
export default {
  name: "Wiki",
  components: {
    NotionWiki: () => import("@/components/NotionWiki.vue"),
  },
  data: () => ({
    homeId: "58d6e1458e87474b9757157719707c6f",
    rootId: "e4a67690ec094aa991da07b7a2a74cb7",
    name: "wiki",
  }),
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style></style>
